// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3zTsD","search":"Settings_search__13Ob5","filter":"Settings_filter__VGM1h"};